/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef } from 'react';
import { func, number, bool } from 'prop-types';

// TODO: Move it to Fpay ui
import { Input as TextField } from 'fpay-ui';

import { moneyFormat as formatCurrency } from '@helpers';
import { REGIONS, decimalSeparator, thousandSeparator } from '@constants/regions';
import { getEnv } from '@config';

const { country } = getEnv();

const { decimalCount: maximumFractionDigits } = REGIONS[country];

const fillZeros = (amountZeros) =>
  ({
    0: '',
    1: '0',
    2: '00',
  }[amountZeros] || '');

const isPositionThousand = (position) => {
  const countDecimals = maximumFractionDigits ? maximumFractionDigits + 1 : 0;
  const positionCheck = position - countDecimals;
  return positionCheck > 0 && positionCheck % 3 === 0;
};

const clearStringOnlyNumbers = (number) => `${number}`.toString().replace(/[^0-9]/g, '');

const clearOnlyPositiveNumber = (number) => {
  if (typeof number === 'number') {
    return number < 0 ? number * -1 : number;
  }

  // strips everything that is not a number (positive)
  return Number(clearStringOnlyNumbers(number));
};
const placeholderDefault = formatCurrency(0);

const IntlCurrencyInput = ({
  component: InputComponent,
  value: valueProps,
  defaultValue,
  max,
  autoFocus,
  autoSelect,
  autoReset,
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  helperTextError,
  helperTextValue,
  placeholder: placeholderProps,
  ...otherProps
}) => {
  const inputRef = useRef(null);

  const [maskedValue, setMaskedValue] = useState('0');
  const [positionBehindValueProps, setPositionBehindValueProps] = useState(null);

  const upgradePosition = (positionBehind) => {
    if (!inputRef || !inputRef.current || document.activeElement !== inputRef.current) {
      return;
    }
    let setPosition = inputRef?.current?.value?.length - positionBehind;
    if (positionBehind === null && maximumFractionDigits > 0) {
      setPosition = inputRef.current.value?.length - maximumFractionDigits - 1;
    }
    inputRef.current.setSelectionRange(setPosition, setPosition);
  };

  const normalizeValue = (number) => {
    let safeNumber = number;

    if (typeof number === 'string') {
      if (maximumFractionDigits > 0) {
        const [integer, decimal, resto] = number.split(decimalSeparator);
        if (decimal) {
          const onlyNumberDecimalString = clearStringOnlyNumbers(decimal);
          const lengthDecimal = `${onlyNumberDecimalString}`.length;
          let newDecimals = `${onlyNumberDecimalString}`.slice(0, maximumFractionDigits);
          if (lengthDecimal < maximumFractionDigits) {
            newDecimals =
              clearOnlyPositiveNumber(onlyNumberDecimalString) === 0
                ? fillZeros(maximumFractionDigits)
                : clearOnlyPositiveNumber(onlyNumberDecimalString) *
                  10 ** (maximumFractionDigits - lengthDecimal);
          }
          safeNumber = clearOnlyPositiveNumber(`${integer}${newDecimals}`);

          setPositionBehindValueProps((prev) => {
            let newValue = prev - 1;
            if (prev === 0 || prev === -1 || prev > maximumFractionDigits) newValue = prev;
            if (lengthDecimal < maximumFractionDigits) newValue = prev + 1;
            if (resto) newValue = maximumFractionDigits;

            if (prev === newValue) {
              upgradePosition(newValue);
              return prev;
            }
            return newValue;
          });
        } else {
          setPositionBehindValueProps((prev) => {
            let newValue = maximumFractionDigits + 1;
            if (resto && decimal === '') newValue = maximumFractionDigits;

            if (prev === newValue) {
              upgradePosition(newValue);
              return prev;
            }
            return newValue;
          });
          safeNumber = (clearOnlyPositiveNumber(integer) || 0) * 10 ** maximumFractionDigits;
        }
      } else {
        safeNumber = clearOnlyPositiveNumber(number);
      }
    } else {
      // all input numbers must be a float point (for the cents portion). This is a fallback in case of integer ones.
      safeNumber = Number.isInteger(number)
        ? Number(number) * 10 ** maximumFractionDigits
        : number.toFixed(maximumFractionDigits);
    }

    // divide it by 10 power the maximum fraction digits.
    return clearOnlyPositiveNumber(safeNumber) / 10 ** maximumFractionDigits;
  };

  const calculateValues = (inputFieldValue) => {
    const value = normalizeValue(inputFieldValue);
    const maskedValue = formatCurrency(value);

    return [value, maskedValue];
  };

  const updateValues = (value) => {
    const [calculatedValue, calculatedMaskedValue] = calculateValues(value);

    if (!max || calculatedValue <= max) {
      setMaskedValue(calculatedMaskedValue);

      return [calculatedValue, calculatedMaskedValue];
    }
    return [normalizeValue(maskedValue), maskedValue];
  };

  const handleKeyDown = (event) => {
    const { keyCode } = event;
    const selectionStart = inputRef?.current?.selectionStart;
    const selectionEnd = inputRef?.current?.selectionEnd;
    const value = inputRef?.current?.value;
    const currentPositionBehind = value?.length - selectionStart;
    if (keyCode === 8 && selectionStart === selectionEnd) {
      const newPosition = currentPositionBehind + 1;
      if (maximumFractionDigits > 0 && currentPositionBehind === maximumFractionDigits) {
        setPositionBehindValueProps((prev) => {
          if (prev === newPosition) {
            upgradePosition(newPosition);
            return prev;
          }
          return newPosition;
        });
        event.preventDefault();
        return;
      }
      if (thousandSeparator && currentPositionBehind > maximumFractionDigits) {
        const cantidadComas = value.slice(selectionStart + 1).split(thousandSeparator).length - 1;
        if (isPositionThousand(currentPositionBehind - cantidadComas)) {
          setPositionBehindValueProps((prev) => {
            if (prev === newPosition) {
              upgradePosition(newPosition);
              return prev;
            }
            return newPosition;
          });
          event.preventDefault();
          return;
        }
      }
    }
    if (keyCode === 46 && selectionStart === selectionEnd) {
      if (maximumFractionDigits > 0 && currentPositionBehind === maximumFractionDigits + 1) {
        setPositionBehindValueProps((prev) => {
          if (prev === maximumFractionDigits) {
            upgradePosition(maximumFractionDigits);
            return prev;
          }
          return maximumFractionDigits;
        });
        event.preventDefault();
        return;
      }
      if (thousandSeparator && currentPositionBehind > maximumFractionDigits) {
        const cantidadComas = value.slice(selectionStart + 2).split(thousandSeparator).length;
        if (isPositionThousand(currentPositionBehind - cantidadComas)) {
          const newPosition = currentPositionBehind - 1;
          setPositionBehindValueProps((prev) => {
            if (prev === newPosition) {
              upgradePosition(newPosition);
              return prev;
            }
            return newPosition;
          });
          event.preventDefault();
        }
      }
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { value, selectionStart } = event.target;
    const position = value?.length === 0 ? null : value?.length - selectionStart;
    setPositionBehindValueProps((prev) => {
      if (prev === position) {
        upgradePosition(position);
        return prev;
      }
      return position;
    });
    const [newvalue, newMaskedValue] = updateValues(value);

    if (newMaskedValue) {
      onChange(event, newvalue, newMaskedValue);
    }
  };

  const handleBlur = (event) => {
    if (onFocus) onBlur(event);
  };

  const handleFocus = (event) => {
    if (autoSelect) {
      event.target.select();
    }

    if (onFocus) onFocus(event);
  };

  const handleKeyUp = (event) => onKeyPress(event, event.key, event.keyCode);

  useEffect(() => {
    const currentValue = valueProps || defaultValue || 0;
    const [, maskedValue] = calculateValues(currentValue);

    setMaskedValue(maskedValue);
    upgradePosition(positionBehindValueProps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueProps, defaultValue, positionBehindValueProps]);

  return (
    <>
      <TextField
        {...otherProps}
        ref={inputRef}
        value={valueProps !== 0 ? maskedValue : ''}
        placeholder={placeholderProps || placeholderDefault}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        onKeyUp={handleKeyUp}
        onKeyDown={handleKeyDown}
        inputMode="numeric"
      />
      {helperTextError && <div style={{ marginTop: '4px' }}>{helperTextValue}</div>}
    </>
  );
};

IntlCurrencyInput.propTypes = {
  defaultValue: number,
  value: number,
  max: number,
  autoFocus: bool.isRequired,
  autoSelect: bool.isRequired,
  autoReset: bool.isRequired,
  onChange: func.isRequired,
  onBlur: func.isRequired,
  onFocus: func.isRequired,
  onKeyPress: func.isRequired,
};

IntlCurrencyInput.defaultProps = {
  value: 0,
  autoFocus: false,
  autoSelect: false,
  autoReset: false,
  onChange: (f) => f,
  onBlur: (f) => f,
  onFocus: (f) => f,
  onKeyPress: (f) => f,
};

export default IntlCurrencyInput;
